import { __decorate } from "tslib";
import React from 'react';
import { observer } from 'mobx-react';
import Menu, { Item } from 'choerodon-ui/lib/rc-components/menu';
import { action } from 'mobx';
import autobind from '../_util/autobind';
import { getItemKey, MORE_KEY, Select } from '../select/Select';
import DataSet from '../data-set';
import { FieldType } from '../data-set/enum';
import Icon from '../icon';
import { preventDefault } from '../_util/EventManager';
const defaultMatcher = (value, inputText) => value.indexOf(inputText) !== -1;
let AutoComplete = class AutoComplete extends Select {
    constructor() {
        super(...arguments);
        this.isChoose = false;
        this.inputText = '';
    }
    get multiple() {
        return false;
    }
    get range() {
        return false;
    }
    getTriggerIconFont() {
        return '';
    }
    getNotFoundContent() {
        return null;
    }
    getOmitPropsKeys() {
        return super.getOmitPropsKeys().concat([
            'searchable',
            'matcher',
        ]);
    }
    isSearchFieldInPopup() {
        return false;
    }
    renderLengthInfo(maxLength, inputLength) {
        const { prefixCls } = this;
        return maxLength && maxLength > 0 ? (React.createElement("div", { key: "length-info", className: `${prefixCls}-length-info` }, `${inputLength}/${maxLength}`)) : null;
    }
    handleChange(e) {
        this.isChoose = false;
        super.handleChange(e);
    }
    choose(record) {
        this.isChoose = true;
        super.choose(record);
    }
    handleFocus(e) {
        const { target } = e;
        this.inputText = target ? target.value : '';
        super.handleFocus(e);
    }
    handleBlur(e) {
        if (!e.isDefaultPrevented()) {
            if (!this.isChoose) {
                const inputText = this.text || this.inputText;
                this.inputText = inputText;
                const temDs = new DataSet({
                    fields: [
                        { name: this.textField, type: FieldType.string },
                        { name: this.valueField, type: FieldType.string },
                    ],
                    data: [{
                            [this.textField]: inputText,
                            [this.valueField]: inputText,
                        }],
                }, { getConfig: this.getContextConfig });
                this.choose(temDs.current);
            }
            super.handleBlur(e);
        }
    }
    getMenu(menuProps = {}) {
        const { options } = this;
        if (!options) {
            return null;
        }
        const { disabled: menuDisabled, textField, valueField, props: { dropdownMenuStyle, optionRenderer, onOption, matcher = defaultMatcher }, } = this;
        const optGroups = [];
        const selectedKeys = [];
        const inputText = this.text || this.inputText;
        options.forEach(record => {
            const value = record.get(valueField);
            // 判断是否符合自动补全的条件
            if (inputText && !matcher(value, inputText)) {
                return;
            }
            const text = record.get(textField);
            const optionProps = onOption({ dataSet: options, record });
            const optionDisabled = menuDisabled || (optionProps && optionProps.disabled);
            const key = getItemKey(record, text, value);
            const itemContent = optionRenderer
                ? optionRenderer({ dataSet: this.options, record, text, value })
                : text;
            const option = (React.createElement(Item, Object.assign({}, optionProps, { key: key, value: record, disabled: optionDisabled }), itemContent));
            optGroups.push(option);
        });
        if (!optGroups.length) {
            return null;
        }
        const menuPrefix = this.getMenuPrefixCls();
        return (React.createElement(Menu, Object.assign({ ref: this.saveMenu, disabled: menuDisabled, defaultActiveFirst: true, multiple: this.menuMultiple, selectedKeys: selectedKeys, prefixCls: menuPrefix, onClick: this.handleMenuClick, onMouseDown: preventDefault, style: dropdownMenuStyle, focusable: false }, menuProps),
            optGroups,
            options.paging && options.currentPage < options.totalPage && (React.createElement(Item, { key: MORE_KEY, checkable: false, className: `${menuPrefix}-item-more` },
                React.createElement(Icon, { type: "more_horiz" })))));
    }
};
AutoComplete.displayName = 'AutoComplete';
AutoComplete.defaultProps = {
    ...Select.defaultProps,
    searchable: true,
    suffixCls: 'auto-complete',
    matcher: defaultMatcher,
};
__decorate([
    autobind,
    action
], AutoComplete.prototype, "handleChange", null);
__decorate([
    autobind
], AutoComplete.prototype, "handleFocus", null);
__decorate([
    autobind
], AutoComplete.prototype, "handleBlur", null);
__decorate([
    autobind
], AutoComplete.prototype, "getMenu", null);
AutoComplete = __decorate([
    observer
], AutoComplete);
export default AutoComplete;
